import { createGuard, nullable } from '@24i/nxg-core-utils/src/guards';
import * as t from 'io-ts';
import { SubtitleGuard } from './subtitles';

const DrmDataGuard = createGuard('DrmData', undefined, {
    licenseUrl: nullable(t.string),
    certificateUrl: nullable(t.string),
    cmsid: nullable(t.string),
    vid: nullable(t.string),
    event: nullable(t.string),
    authToken: nullable(t.string),
    sessionUrl: nullable(t.string),
    adsUrl: nullable(t.string),
    adsParams: nullable(t.record(t.string, t.any)),
});

const ThumbnailsDataGuard = createGuard('Thumbnails', undefined, {
    type: t.literal('spritesheet'),
    data: createGuard('ThumbnailData', undefined, {
        interval: t.union([t.number, t.array(t.number), t.null, t.undefined]),
        image: nullable(t.string),
        orientation: nullable(t.string),
        gridCols: nullable(t.number),
        frame: nullable(
            createGuard('ThumbnailFrame', {
                width: t.number,
                height: t.number,
            })
        ),
    }),
});

export const StreamGuard = createGuard(
    'Stream',
    {
        type: t.string,
        drm: t.string,
    },
    {
        url: nullable(t.string),
        urlSrc: nullable(t.string),
        urlSrcService: nullable(t.string),
        advertisement: nullable(t.string),
        data: nullable(DrmDataGuard),
        thumbnails: nullable(ThumbnailsDataGuard),
        subtitles: nullable(t.array(SubtitleGuard)),
    }
);

export type Stream = t.TypeOf<typeof StreamGuard>;
